module.exports = __webpack_public_path__ + "img/beanpod.c0facf40.svg";